"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const downloads_1 = require("../../api/downloads");
const configuration_1 = __importDefault(require("../apis/configuration/downloads/configuration"));
class ResellerFileExplorerStore {
    api = new downloads_1.ResellerApi(configuration_1.default);
    loading = false;
    directoryStructure = new Map();
    files = new Map();
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            isLoading: mobx_1.computed,
            structure: mobx_1.observable,
            loading: mobx_1.observable,
            directoryStructure: mobx_1.observable,
            files: mobx_1.observable,
            loadStructure: mobx_1.action.bound,
        });
    }
    get isLoading() {
        return this.loading;
    }
    structure(relativePath) {
        return this.directoryStructure.get(relativePath) ?? [];
    }
    loadStructure(relativePath) {
        this.loading = true;
        return this.api
            .getResellerStructure({
            relativePath: relativePath,
        })
            .then((0, mobx_1.action)((directoryStructure) => {
            this.directoryStructure.set(relativePath, directoryStructure);
            return this.directoryStructure.get(relativePath) ?? [];
        }))
            .finally((0, mobx_1.action)(() => (this.loading = false)));
    }
    getFiles(path) {
        return this.files.get(path) ?? [];
    }
    loadFiles(selectedPath) {
        return this.api
            .getResellerFiles({
            path: selectedPath,
        })
            .then((files) => {
            this.files.set(selectedPath, files);
            return files;
        });
    }
}
exports.default = new ResellerFileExplorerStore();
